export default {
  create () {
    return {}
  }
}
